import React, { useState, useEffect } from "react";
// import React from "react";
import {
    Table, Input, Space,
    Drawer, Tooltip, Switch, Modal
} from 'antd';
import Button from "antd-button-color";
import Highlighter from 'react-highlight-words';
import { SearchOutlined, PlusOutlined, DeleteOutlined, ToolOutlined, UndoOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { getUserRoleList, userRoleStatus, getRole } from "./service";
import Addform from "./addform"
import Editform from "./editform"

const { confirm } = Modal;
function success(e) {
    // console.log('www', e)
    let secondsToGo = 15;
    const onOkModal = () => {
        window.location.reload();
    }
    const modal = Modal.success({
        title: 'จัดการข้อมูลผู้ใช้งาน เรียบร้อยแล้ว!',
        okText: 'OK',
        onOk: () => {
            onOkModal()
        },
    });
    const timer = setInterval(() => {
        secondsToGo -= 1;
    }, 1000);
    setTimeout(() => {
        clearInterval(timer);
        modal.destroy();
        window.location.reload();
    }, secondsToGo * 1000);
}

function showConfirm(e) {
    // console.log('e', e)
    if (e.e == true) {
        // console.log('เปิด');
        confirm({
            title: 'ต้องการเปิดการใช้งานผู้ใช้งานนี้ ใช่หรือไม่?',
            icon: <ExclamationCircleOutlined />,
            content: e.record.role_desc,
            okText: 'ใช่',
            // okType: 'danger',
            cancelText: 'ไม่ใช่',
            onOk() {
                // console.log('OK');
                let data = {
                    "status": 'active',
                    "id": e.record.id
                }
                userRoleStatus(data).then(res => {
                    // console.log("res===", res)
                    if (res && res.status === 200) {
                        success('no')
                    }
                })
            },
            onCancel() {
                // console.log('Cancel');
            },
        });
    } else {
        // console.log('ปิด');
        confirm({
            title: 'ต้องการปิดการใช้งานผู้ใช้งานนี้ ใช่หรือไม่?',
            icon: <ExclamationCircleOutlined />,
            content: e.record.role_desc,
            okText: 'ใช่',
            // okType: 'danger',
            cancelText: 'ไม่ใช่',
            onOk() {
                // console.log('OK');
                let data = {
                    "status": 'not active',
                    "id": e.record.id
                }
                userRoleStatus(data).then(res => {
                    // console.log("res===", res)
                    if (res && res.status === 200) {
                        success('off')
                        // form.resetFields();
                    }
                })
            },
            onCancel() {
                // console.log('Cancel');
            },
        });
    }
}

class Role extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            searchText: '',
            searchedColumn: '',
            sortedInfo: null,
            data: null,
            visibleAdd: false,
            visibleEdit: false,
            staffDetail: null,
            current: 1,
            pageSize: 10,
            role_data: [],
            load: true
        };
    }

    componentDidMount() {
        // console.log('componentDidMount', this.props)
        this.getData();
    }

    getData = () => {
        getUserRoleList().then(res => {
            // console.log("res===", res)
            if (res && res.status === 200) {
                this.setState({
                    data: res.data.info
                })
            }
        })
        getRole().then(res => {
            // console.log("res===2", res)
            if (res && res.status === 200) {
                this.setState({
                    role_data: res.data,
                    load: false
                })
            }
        })
    }

    getColumnSearchProps = dataIndex => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={node => {
                        this.searchInput = node;
                    }}
                    placeholder={`Search ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{ width: 188, marginBottom: 8, display: 'block' }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Search
                    </Button>
                    <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                        Reset
                    </Button>
                    <Button
                        type="link"
                        size="small"
                        onClick={() => {
                            confirm({ closeDropdown: false });
                            this.setState({
                                searchText: selectedKeys[0],
                                searchedColumn: dataIndex,
                            });
                        }}
                    >
                        Filter
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
        onFilter: (value, record) =>
            record[dataIndex]
                ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
                : '',
        onFilterDropdownVisibleChange: visible => {
            if (visible) {
                setTimeout(() => this.searchInput.select(), 100);
            }
        },
        render: text =>
            this.state.searchedColumn === dataIndex ? (
                <Highlighter
                    highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                    searchWords={[this.state.searchText]}
                    autoEscape
                    textToHighlight={text ? text.toString() : ''}
                />
            ) : (
                text
            ),
    });

    getColumnSearchProps2 = dataIndex => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={node => {
                        this.searchInput = node;
                    }}
                    placeholder={`Search ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{ width: 188, marginBottom: 8, display: 'block' }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Search
                    </Button>
                    <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                        Reset
                    </Button>
                    <Button
                        type="link"
                        size="small"
                        onClick={() => {
                            confirm({ closeDropdown: false });
                            this.setState({
                                searchText: selectedKeys[0],
                                searchedColumn: dataIndex,
                            });
                        }}
                    >
                        Filter
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
        onFilter: (value, record) =>
            record[dataIndex]
                ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
                : '',
        onFilterDropdownVisibleChange: visible => {
            if (visible) {
                setTimeout(() => this.searchInput.select(), 100);
            }
        },
    });

    handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        this.setState({
            searchText: selectedKeys[0],
            searchedColumn: dataIndex,
        });
    };

    handleReset = clearFilters => {
        clearFilters();
        this.setState({ searchText: '' });
    };

    handleChange = (pagination, filters, sorter) => {
        // console.log('Various parameters', pagination, filters, sorter);
        this.setState({
            filteredInfo: filters,
            sortedInfo: sorter,
            current: pagination.current,
            pageSize: pagination.pageSize
        });
    };

    clearFilters = () => {
        this.setState({ filteredInfo: null });
    };

    clearAll = () => {
        this.setState({
            filteredInfo: null,
            sortedInfo: null,
        });
    };

    setAgeSort = () => {
        this.setState({
            sortedInfo: {
                order: 'descend',
                columnKey: 'age',
            },
        });
    };

    showDrawerAdd = () => {
        this.setState({
            visibleAdd: true,
        });
    };

    showDrawerEdit = (e) => {
        // console.log("showDrawerEdit", e.record)

        this.setState({
            visibleEdit: true,
            staffDetail: e.record
        });
    };

    onCloseAdd = () => {
        this.setState({
            visibleAdd: false,
        });
    };

    onCloseEdit = () => {
        this.setState({
            visibleEdit: false,
            // staffDetail: null
        });
    };

    dd = () => {
        console.log("this.state", this.state)
    }
    renderEditForm = (level) => {
        // console.log("render", this.state.staffDetail)
        return (
            <Drawer
                title="แก้ไขสิทธิ์ผู้ใช้งาน"
                width={720}
                onClose={this.onCloseEdit}
                visible={this.state.visibleEdit}
                bodyStyle={{ paddingBottom: 1 }}

            >
                <Editform
                    userDetail={this.state.staffDetail}
                />
            </Drawer>
        )
    }

    onChangeSwitch = (checked) => {
        showConfirm(checked)
    }

    render() {

        var current = this.state.current
        var pageSize = this.state.pageSize
        var role_data = this.state.role_data
        var load = this.state.load
        var columns = [
            {
                title: 'ลำดับ',
                align: 'center',
                width: '4%',
                key: 'no',
                render: (text, record, index) => {
                    return (((current - 1) * pageSize) + index + 1)
                },
            },
            {
                title: 'ชื่อผู้ใช้งาน(BO)',
                dataIndex: 'email',
                key: 'email',
                width: '15%',
                ...this.getColumnSearchProps('email'),
            },
            {
                title: 'ชื่อกลุ่มผู้ใช้งาน',
                // dataIndex: 'URID',
                key: 'URID',
                width: '15%',
                render: ((text, record) => {
                    var ss = role_data.find(({ URID }) => URID === record.URID)
                    return (
                        <div onClick={() => {
                            // console.log("record", record)
                        }}>
                            {ss.role_desc}
                        </div>
                    )
                }),
                // ...this.getColumnSearchProps('URID'),
            },
            {
                title: 'เขตการขาย',
                dataIndex: 'territory_desc_text',
                key: 'territory_desc_text',
                width: '25%',
                ...this.getColumnSearchProps('territory_desc_text'),
            },
            {
                title: 'แก้ไข',
                key: 'action',
                width: '5%',
                align: 'center',
                fixed: 'right',
                render: (text, record) => (
                    <Space size="small">
                        <Tooltip title="edit user">
                            <Button with="ghost" type="success" shape="circle" icon={<ToolOutlined />} size="small"
                                // onClick={this.showDrawerEdit}
                                onClick={() => {
                                    this.showDrawerEdit({ record })
                                    // console.log("record", record)
                                }
                                }
                            />
                        </Tooltip>
                        {/* <Tooltip title="reset password">
                            <Button with="ghost" type="warning" shape="circle" icon={<UndoOutlined />} size="small" />
                        </Tooltip> */}

                    </Space>
                ),
            },
            {
                title: 'สถานะ',
                key: 'status',
                width: '7%',
                align: 'center',
                fixed: 'right',
                render: (text, record) => (
                    <Tooltip title={record.isActive == 1 ? "active" : "not active"}>
                        <Switch
                            defaultChecked={record.isActive == 1 ? true : false}
                            onChange={(e) => {
                                this.onChangeSwitch({ e, record })
                                // console.log("record", record)
                            }
                            }
                            checkedChildren="เปิด"
                            unCheckedChildren="ปิด"
                        />
                    </Tooltip>
                ),
                ellipsis: true,
                // ...this.getColumnSearchProps2('isActive'),
            },
        ]
        if (load) {
            return (
                <div>
                    loading
                </div>
            );
        } else {
            return (
                <>
                    <Space style={{ marginBottom: 16 }}>
                        <h2 onClick={this.dd}>จัดการสิทธิ์ผู้ใช้งาน</h2>
                    </Space>
                    {/* <Button type="primary" onClick={this.showDrawerAdd} style={{ float: 'right' }}>
                    <PlusOutlined /> Add
                </Button> */}
                    <Table
                        className="myTable"
                        rowClassName={(record, index) => index % 2 === 0 ? 'table-row-light' : 'table-row-dark'}
                        columns={columns}
                        dataSource={this.state.data}
                        onChange={this.handleChange}
                        // scroll={{ x: 1500, y: 300 }}
                        scroll={{ x: 800, y: '100%' }}
                        size="small"
                        rowKey="id"
                        bordered
                        pagination={false}
                    />
                    {/* <Drawer
                    title="เพิ่มกลุ่มผู้ใช้งาน"
                    width={720}
                    onClose={this.onCloseAdd}
                    visible={this.state.visibleAdd}
                    bodyStyle={{ paddingBottom: 1 }}
                >
                    <Addform />
                </Drawer> */}
                    { this.state.visibleEdit ? this.renderEditForm() : <></>}
                </>
            )
        }
    }
}

export default Role;
